import React, { useState } from 'react';

import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputBase from '@material-ui/core/InputBase/InputBase';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import CloseIcon from '../../assets/icons/CloseIcon';
import SearchIcon from '../../assets/icons/SearchIcon';
import { useEventListener } from '../../utils/hooks';
import useStyles from './styles';

const SearchInput = ({ wrapperClass, isOpen = false, toggle }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const [value, setValue] = useState('');

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const search = () => {
    if (!isOpen) return;
    if (!value) return;
    toggle();
    history.push(`/discover/search/?s=${value}`);
  };

  useEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      search();
    }
  });

  useEventListener('keyup', (e) => {
    if (e.key === 'Escape' && isOpen) {
      toggle();
    }
  });

  return (
    <div
      onClick={!isOpen ? toggle : () => {}}
      className={cx(classes.wrapper, isOpen && classes.wrapperOpen, wrapperClass)}
    >
      {isOpen && (
        <IconButton className={classes.closeIconWrapper} aria-label="close" onClick={toggle}>
          <CloseIcon />
        </IconButton>
      )}
      <div className={classes.inputWrapper}>
        {isOpen ? (
          <InputBase
            className={classes.input}
            value={value}
            onChange={onChange}
            placeholder={t('input.placeholder.search')}
            autoFocus={isOpen}
            inputProps={{ 'aria-label': 'enter key words' }}
          />
        ) : (
          <Typography className={classes.searchPlaceholder}>Search</Typography>
        )}
        <IconButton type="submit" aria-label="search" onClick={isOpen ? search : toggle}>
          <SearchIcon className={classes.searchIcon} />
        </IconButton>
      </div>
    </div>
  );
};

export default SearchInput;
